import _map from "lodash/map"
import _filter from "lodash/filter"
import _find from "lodash/find"
import _capitalize from "lodash/capitalize"
import moment from "moment"
import { maskTel } from "services/utils/mask"

moment.locale("pt-br")

export const formatStatusText = (data) => {
  const status = {
    AGENDAR: "Agendado",
    REAGENDAR: "Reagendado",
    CANCELAR: "Cancelado"
  }

  return status[data.stringFieldValue]
}

export const formatStatusType = (data) => {
  const type = {
    AGENDAR: "success",
    REAGENDAR: "warning",
    CANCELAR: "error"
  }

  return type[data.stringFieldValue]
}

export const formatServiceRequestData = (data) => {
  return _map(data, (item) => {
    const filter = _filter(
      item.fields,
      (field) => field.fieldName === "OPERATION_TYPE"
    )

    return {
      ...item,
      fields: filter
    }
  })
}

export const normalizeProtocolDetails = (details, productServiceRequest) => {
  const currentProtocolDetail = _find(
    productServiceRequest,
    (item) => item.id === details.id
  )

  const type = _find(
    details.fields,
    (item) => item.fieldName === "OPERATION_TYPE"
  )

  const startDate = findStartDate(currentProtocolDetail)

  const endDate = findEndDate(currentProtocolDetail)

  const targetPhoneList = _find(
    currentProtocolDetail.fields,
    (item) =>
      item.fieldName === "SCHEDULED_TARGET_PHONE_LIST" ||
      item.fieldName === "TARGET_PHONE_LIST"
  )
  const phoneList = JSON.parse(targetPhoneList.stringFieldValue)

  const phoneDetails = formatPhoneNumberDetails(phoneList)
  const protocolDetails = formatProtocolDetails(
    details,
    startDate,
    endDate,
    type
  )

  return {
    details: protocolDetails,
    phoneDetails
  }
}

const findStartDate = (protocol) => {
  const date = _find(
    protocol.fields,
    (item) =>
      item.fieldName === "SCHEDULED_START_DATE" ||
      item.fieldName === "START_DATE"
  )
  return formatDate(date.dateFieldValue || date.stringFieldValue)
}

const findEndDate = (protocol) => {
  const date = _find(
    protocol.fields,
    (item) =>
      item.fieldName === "SCHEDULED_END_DATE" || item.fieldName === "END_DATE"
  )

  return formatDate(date.dateFieldValue || date.stringFieldValue)
}

const formatDate = (date) => {
  return moment(date).format("DD/MM/YYYY HH:mm")
}

export const formatDateOrTime = (value, isTime) => {
  if (isTime) {
    return value ? moment(value).format("HH:mm") : ""
  }
  return value ? moment(value, "YYYY/MM/DD") : ""
}

const formatProtocolDetails = (details, startDate, endDate, type) => {
  return [
    {
      key: "DDG:",
      value: details.agreementReference || "-"
    },

    {
      key: "Protocolo:",
      value: details.protocol || "-"
    },

    {
      key: "Realizado em:",
      value: formatDate(details.createdAt) || "-"
    },

    {
      key: "Data de início:",
      value: startDate || "-"
    },

    {
      key: "Data de finalização:",
      value: endDate || "-"
    },

    {
      key: "Tipo de solicitação:",
      value: _capitalize(type.stringFieldValue) || "-"
    }
  ]
}

const formatPhoneNumberDetails = (data) => {
  return _map(data, (item) => {
    return {
      infoNumber: [
        {
          key: "Número regenerado:",
          value: maskTel(item.phoneNumber)
        },
        {
          key: "Percentual de redirecionamento de chamadas:",
          value: `${item.percentage}%`
        }
      ]
    }
  })
}

export const payloadSchedule = {
  customerId: "",
  phoneNumber: "",
  documentNumber: "",
  productLine: "TELEFONIA FIXA",
  requestChannel: "PORTAL",
  requestType: "SOLICITACAO DE SERVICO DE REDIRECIONAMENTO CARGA",
  worklogText: "SS de Redirecionamento de Carga",
  assetId: "",
  loadRedirect: {
    operationType: "",
    originPhoneNumber: "",
    targetPhoneList: "",
    startDate: "",
    endDate: ""
  },
  originSystem: "PORTAL"
}

export const recalculateRedirectPercentage = (phoneList) => {
  if (!phoneList.length) return

  const percentage = Math.floor(10 / phoneList.length)
  return _map(phoneList, (item) => {
    return {
      ...item,
      percentage: percentage * 10
    }
  })
}



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/helpers.js